export default __webpack_public_path__ + "static/media/service-blueprint.1e71796b.webp";